import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
    list: {
        flex: 1,
        backgroundColor: '#F5F5F5',
    },
    contentContainer: {
        paddingVertical: 8,
    },
    timeDivider: {
        alignItems: 'center',
        paddingVertical: 8,
    },
    timeDividerText: {
        fontSize: 11,
        color: '#BBBBBB',
        backgroundColor: '#ECECEC',
        paddingHorizontal: 8,
        paddingVertical: 3,
        borderRadius: 4,
        overflow: 'hidden',
    },
});
